import "./Scaps.scss";
import "@fontsource/inter/700.css";
import "@fontsource/inter/400.css";
import Logo from "./logo.svg";
import LogoUK from "./logo-uk.svg";
import { Box, Image } from "@chakra-ui/react";

function ScapsTemplate(props) {
  return (
    <div className={"page page-wrapper"}>
      <Box pt={[6, 6]} pb={[3, 2]} textAlign={"center"}>
        <Image src={window.locale === "uk" ? LogoUK : Logo} height={[6, 8]} display={"inline-block"} />
      </Box>

      {props.children}
    </div>
  );
}

export default ScapsTemplate;
